import { Component } from '@angular/core';
import { CartService } from './cart.service.js';

import { Product } from '../products/product';
export class AddCartComponent {
/**
 * @param {?} cartService
 */
constructor(
private cartService: CartService
    ) { }
/**
 * @param {?} product
 * @return {?}
 */
addToCart(product: Product) {
        this.cartService.add(product)
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'add-cart',
    template: `<button (click)="addToCart(product)">Add to Cart</button>`,
    inputs: ['product']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CartService, },
];
}

function AddCartComponent_tsickle_Closure_declarations() {
/** @type {?} */
AddCartComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AddCartComponent.ctorParameters;
/** @type {?} */
AddCartComponent.prototype.cartService;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
